$(document).on('ready turbolinks:load', () => {
  _.forEach($('.tmt-pin'), (el) => {
    const $el = $(el);
    const students = $el.data('students');
    if (_.isEmpty(students)) { return; }
    $el.popover({
      container: 'body',
      html: true,
      placement: 'top',
      trigger: 'focus',
      template: '<div class="popover student-popover-wrapper" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content student-popover"></div></div>',
      title: I18n.t('plans.journeys.journey_info.students'),
      content: _(students).sortBy('id').map(s => `<span>${_.padStart(s.id, 3, '0')} - ${s.name} <i class="fa fa-arrow-${s.status === 'entering' ? 'left' : 'right'} arrow-${s.status === 'entering' ? 'green' : 'red'}"></i></span>`).join(''),
    });
  });
});
